import React, { useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Button,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@material-ui/core";
import MenuAv from "../MenuAv/MenuAv";
import Drawer from "../Drawer/Drawer";
import { useTranslation } from "react-i18next";
import {
  Done,
  Translate,
  KeyboardArrowUp,
  ArrowDropDown,
  KeyboardArrowDown,
} from "@material-ui/icons";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: "1%",
  },
  title: {
    flexGrow: 1,
  },
  rightActions: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
  },
  languageButton: {
    color: "white",
    textTransform: "none",
    marginRight: "0.5rem",
  },
});

export default function NavMenu() {
  const classes = useStyles();
  const { t, i18n } = useTranslation(["components"]);
  const [open, setOpen] = useState(false);
  const anchorEl = useRef();

  const languages = [
    { code: "en", label: "English" },
    { code: "es", label: "Espanol" },
    { code: "fr", label: "Francais" },
    { code: "it", label: "Italiano" },
  ];
  const currentLanguage = (
    i18n.resolvedLanguage ||
    i18n.language ||
    "it"
  ).split("-")[0];

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <Drawer />
          <Typography variant="h6" className={classes.title}>
            {t("components:nav_menu.title")}
          </Typography>
          <div className={classes.rightActions}>
            <Button
              className={classes.languageButton}
              aria-controls="language-menu"
              aria-haspopup="true"
              onClick={() => setOpen(true)}
              ref={anchorEl}
              endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            >
              <Translate />
            </Button>
            <Menu
              id="language-menu"
              anchorEl={anchorEl?.current}
              keepMounted
              open={open}
              getContentAnchorEl={null}
              onClose={() => setOpen(false)}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              transformOrigin={{ vertical: "top", horizontal: "center" }}
            >
              {languages.map((lang) => (
                <MenuItem
                  key={lang.code}
                  selected={lang.code === currentLanguage}
                  onClick={() => {
                    i18n.changeLanguage(lang.code);
                    setOpen(false);
                  }}
                >
                  {currentLanguage == lang.code ? (
                    <Done fontSize="small" />
                  ) : (
                    <span style={{ width: 24 }} />
                  )}
                  {lang.label}
                </MenuItem>
              ))}
            </Menu>
            <MenuAv />
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
